﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class FrameBackupClient {
    constructor(baseUrl) {
        if (baseUrl) {
            this.client = new OperationalContextClient_1.OperationalContextClient(baseUrl);
        }
        else {
            this.client = new OperationalContextClient_1.OperationalContextClient();
        }
    }
    backup() {
        return this.client.apiFramebackupsGet();
    }
    backupByOrganization(organizationAppId) {
        return this.client.apiFramebackupsByOrganizationAppIdGet(organizationAppId, null, null);
    }
    backupByOrganizationAndFrameId(organizationAppId, frameId, frameNumber) {
        return this.client.apiFramebackupsByOrganizationAppIdGet(organizationAppId, frameId, frameNumber.toString());
    }
}
exports.FrameBackupClient = FrameBackupClient;
//# sourceMappingURL=FrameBackupClient.js.map